export default "__VITE_ASSET__aodG6wiK__"